import { createContext, useState, ReactNode } from 'react';
import { Toast } from 'utils/createToast';
export type ToastContextType = {
  toastList: Toast[];
  setToastList: React.Dispatch<React.SetStateAction<Toast[]>>;
};
export const ToastContext = createContext<ToastContextType | null>(null);

type Props = {
  children: ReactNode;
};

export const ToastProvider = ({ children }: Props) => {
  const [toastList, setToastList] = useState<Toast[]>([]);

  return <ToastContext.Provider value={{ toastList, setToastList }}>{children}</ToastContext.Provider>;
};
